import { render, staticRenderFns } from "./Size.vue?vue&type=template&id=a14aab2a&scoped=true&"
import script from "./Size.vue?vue&type=script&lang=js&"
export * from "./Size.vue?vue&type=script&lang=js&"
import style0 from "./Size.vue?vue&type=style&index=0&id=a14aab2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14aab2a",
  null
  
)

export default component.exports